import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Text from "./Text";
import ImageControl from "./ImageControl";
import { doObjToFormData, postDateFormat } from "../../helpers/helpers";
import paths from "../../constants/paths";
import http from "../../helpers/http";
import { toast, ToastContainer } from "react-toastify";
import { TOAST_SETTINGS } from "../../utils/siteSettings";
import ReportPopup2 from "./ReportPopup2";

const CirclePost = ({ circle, index }) => {
  const [isReportPopupOpen, setIsReportPopupOpen] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const [activeActionPostId, setActiveActionPostId] = useState(null);
  const [typeStatus, setTypeStatus] = useState(
    circle?.like_status == 1 ? "like" : "unlike"
  );
  const [likeCount, setLikeCount] = useState(circle?.likes || 0);

  const actionRef = useRef(null);
  const authToken = localStorage.getItem("authToken");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (actionRef.current && !actionRef.current.contains(event.target)) {
        setActiveActionPostId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleToggleReportPopup = (post = null) => {
    setSelectedPost(post);
    setIsReportPopupOpen(!isReportPopupOpen);
  };

  const ActionToggle = (postId) => {
    setActiveActionPostId(postId);
  };

  const handleStats = (type) => {
    if (authToken) {
      const formData = {
        post_id: circle?.id,
        type: type,
        token: authToken,
      };
      try {
        http
          .post("save-circle-stats", doObjToFormData(formData))
          .then((response) => {
            const data = response.data || response;
            if (data.status == 1) {
              if (data.type_status == "like") {
                setTypeStatus("like");
              } else {
                setTypeStatus(circle?.like_status);
              }
              setLikeCount(data.count_likes);
            } else {
              toast.error("Technical Error", TOAST_SETTINGS);
            }
          });
      } catch (errors) {
        console.log("Errors", errors);
      }
    } else {
      window.location.replace(paths.SITE_BASE_URL + "/signin");
    }
  };

  return (
    <>
      <ToastContainer />

      {isReportPopupOpen && (
        <ReportPopup2
          handleToggleReportPopup={() => handleToggleReportPopup(null)}
          post={selectedPost}
        />
      )}

      <div className="inner" key={circle.id}>
        <div className="post_header">
          <div className="post_title">
            <h4>
              <Link to={`/learning-hub/${circle.slug || circle.id}`}>
                {circle.title}
              </Link>
            </h4>
            <div className="post_tags">
              {circle.tags.split(",").map((tag, i) => (
                <span key={i}>{tag.trim()}</span>
              ))}
            </div>
          </div>

          <div className="post_date_action">
            <div className="post_date">
              {postDateFormat(circle.created_date) || "N/A"}
            </div>

            <div className="post_action" ref={actionRef}>
              <button type="button" onClick={() => ActionToggle(circle.id)}>
                <img
                  src={paths.SITE_BASE_URL+"/images/action.svg"}
                  alt="action"
                  width="100"
                  height="100"
                />
              </button>
              {activeActionPostId === circle.id && (
                <div className="action_drop">
                  <a
                    href="javascript:void(0)"
                    onClick={(e) => {
                      e.preventDefault();
                      handleToggleReportPopup(circle);
                    }}
                  >
                    Report
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="post_description">
          <Text string={circle.description} parse={true} />
          {circle.image && (
            <div className="image">
              <ImageControl folder="circles" src={circle.image} />
            </div>
          )}
        </div>

        <div className="post_footer">
          <Link to={`/learning-hub/${circle.slug || circle.id}`}>
            <div className="post_footer_action">
              <img
                src={paths.SITE_BASE_URL+"/images/view.svg"}
                alt="views"
                width="100"
                height="100"
              />
              <span>{circle.views}</span>
            </div>
          </Link>

          <div className="post_footer_action">
            <img
              src={
                typeStatus === "like" ? paths.SITE_BASE_URL+"/images/liked.svg" : paths.SITE_BASE_URL+"/images/like.svg"
              }
              alt="likes"
              width="100"
              height="100"
              onClick={() => handleStats("like")}
              style={{ cursor: "pointer" }}
            />
            <span>{likeCount}</span>
          </div>

          <Link to={`/learning-hub/${circle.slug || circle.id}`}>
            <div className="post_footer_action">
              <img
                src={paths.SITE_BASE_URL+"/images/comment.svg"}
                alt="comments"
                width="100"
                height="100"
              />
              <span>{circle.comments}</span>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
};

export default CirclePost;
